import { jsx } from 'react/jsx-runtime';
import SwipeableBottomSheet from 'react-swipeable-bottom-sheet';

const ReactSwipeableBottomSheet = (props) => {
    return jsx(SwipeableBottomSheet, Object.assign({}, props));
};

export { ReactSwipeableBottomSheet as default };
//# sourceMappingURL=SwipeableBottomSheet.js.map
